
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"inherit","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.904.367a.319.319 0 00-.339-.069L.204 7.818a.32.32 0 00-.042.575l4.013 2.261 1.393 6.807a.318.318 0 00.314.263.317.317 0 00.227-.096L9.13 14.6a.32.32 0 00-.451-.451l-2.373 2.379.513-4.39 7.246 3.976a.319.319 0 00.456-.177L19.98.703a.319.319 0 00-.078-.336zM1.064 8.168l15.825-6.146-12.442 8.053-3.383-1.907zm5.292 3.212a.32.32 0 00-.118.22l-.443 3.79-.98-4.793L15.56 3.642 6.356 11.38zm7.687 3.995l-6.925-3.801L18.982 1.6l-4.939 13.774z"}})])
          )
        }
      }
    